import React, { useEffect, useState } from "react";
import { Container, Dropdown, Tab, Tabs } from "react-bootstrap";
import TechnologyActions from "./technologyactions";
import TechnologyAssessment from "./technologyassessment";
import TechnologyAnalysis from "./technologyanalysis";


const Technologyindex = () => {
    const [tabs] = useState([
        { id: 1, sub_category: 'Technology Analysis' },
        { id: 2, sub_category: 'Technology Assessment' },
        { id: 3, sub_category: 'Technology Actions' },
    ]);

    const [activeTab, setActiveTab] = useState('Technology Analysis');
    const [isMobile, setIsMobile] = useState(false);

    const handleTabSelect = (key) => {
        setActiveTab(key);
    };

    const getTabContent = (tabName, activeTab) => {
        switch (tabName) {
            case 'Technology Analysis':
                return <TechnologyAnalysis activeTab={activeTab} />;
            case 'Technology Assessment':
                return <TechnologyAssessment activeTab={activeTab} />;
            case 'Technology Actions':
                return <TechnologyActions activeTab={activeTab} />;
            default:
                return null;
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768); // Set breakpoint for mobile screens
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
      
        <Container fluid>
            {isMobile ? (
                <>
                    <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                            {activeTab}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {tabs.map((tab) => (
                                <Dropdown.Item
                                    key={tab.id}
                                    onClick={() => handleTabSelect(tab.sub_category)}
                                >
                                    {tab.sub_category}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                    {getTabContent(activeTab)} 
                </>
            ) : (
                <Tabs
                    activeKey={activeTab}
                    onSelect={handleTabSelect}
                    id="justify-tab-example"
                    className="border-tab nav-primary mb-3"
                >
                    {tabs.map(tab => (
                        <Tab key={tab.id} eventKey={tab.sub_category} title={tab.sub_category}>
                            {getTabContent(tab.sub_category)} 
                        </Tab>
                    ))}
                </Tabs>
            )}
        </Container>
    );
};

export default Technologyindex;
